import PropTypes from "prop-types";
import { Accordion, Alert, Box } from "../../../themeV2";

const ITEM = "advanced";

export default function AdvancedDisclosure({
  summary,
  isOpen,
  onToggle,
  children,
}) {
  return (
    <Box direction="column" gap={3}>
      <Alert severity="info">{summary}</Alert>

      {/* Accordion.Root is a multi-select list keyed by item value; one item
          open means the list holds that value. */}
      <Accordion.Root
        value={isOpen ? [ITEM] : []}
        onValueChange={(open) => onToggle(open.includes(ITEM))}
      >
        <Accordion.Item value={ITEM}>
          <Accordion.Header>
            <Accordion.Trigger>Advanced fields</Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Panel>{children}</Accordion.Panel>
        </Accordion.Item>
      </Accordion.Root>
    </Box>
  );
}

AdvancedDisclosure.propTypes = {
  summary: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
